import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import ReclaimLicensesStore from '../Store';
import CheckmarkIcon from './SucceededBody/CheckmarkIcon';

interface Props {
  reclaimLicensesStore: ReclaimLicensesStore;
}

function Header({ reclaimLicensesStore: ReclaimLicensesStore }: Props) {
  switch (ReclaimLicensesStore.state.kind) {
    case 'ready':
    case 'error':
      return (
        <>
          <h3 className="px-4 pt-4 text-xl font-semibold">
            <T kind="Remove Access" />
          </h3>
          <p className="px-4 pb-4 text-sm">
            <T kind="Remove login and collection access. Any licenses will be returned for reuse." />
          </p>
          <p className="px-4 text-lg font-semibold mt-4">
            <T kind="Impacted Participants" />
          </p>
        </>
      );
    case 'succeeded':
      return <CheckmarkIcon className="mx-auto mt-16" />;
    case 'updating':
      return <></>;
  }
}

export default observer(Header);
